export const getFnfCurrencySymbol = (currency?: string | null) => {
	if (currency === 'USD') return '$';
	if (currency === 'ZMW') return 'K';
	return null;
};

export const formatFnfAmount = (
	value?: number | null,
	currency?: string | null,
) => {
	if (value === null || value === undefined) return '-';
	const formatted = Number(value).toLocaleString('en-GB', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	const symbol = getFnfCurrencySymbol(currency);
	return symbol ? `${symbol} ${formatted}` : formatted;
};
